var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsNewLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.89395 23.52C6.14215 23.84 7.44095 24 8.79035 24C11.6241 24 13.8675 23.344 15.5205 22.032C17.1735 20.72 18 18.944 18 16.704C18 15.296 17.6964 14.16 17.0892 13.296C16.4819 12.4 15.6892 11.696 14.7108 11.184C13.7663 10.64 12.7542 10.224 11.6747 9.936L7.43521 13.9727L3.59293 17.6229L0 21.0362C0.451304 21.4155 0.935631 21.7634 1.45298 22.08C2.49877 22.688 3.64576 23.168 4.89395 23.52Z",
    fill: "url(#paint0_linear_475_817)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.997559 10.464C1.60479 11.328 2.38069 12.016 3.32527 12.528C4.01198 12.8649 4.7153 13.1545 5.43524 13.3969L9.68915 9.35561L13.1441 6.07338L16.7773 2.62177C16.0207 1.94994 15.1631 1.41202 14.2048 1.008C12.7205 0.336 11 0 9.04336 0C7.18793 0 5.58552 0.288 4.23612 0.863999C2.92045 1.44 1.89154 2.256 1.14937 3.312C0.440932 4.368 0.0867145 5.632 0.0867145 7.104C0.0867145 8.48 0.390329 9.6 0.997559 10.464Z",
    fill: "url(#paint1_linear_475_817)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_475_817",
    x1: 13.5021,
    y1: 2.99079,
    x2: 2.41154,
    y2: 19.6176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5046E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D7EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_475_817",
    x1: 13.5021,
    y1: 2.99079,
    x2: 2.41154,
    y2: 19.6176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5046E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D7EFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsNewLogo);
export default __webpack_public_path__ + "static/media/as_new_logo.facf2f79808f1a6e31f27ea4e27f67e9.svg";
export { ForwardRef as ReactComponent };